import { combineReducers } from '@reduxjs/toolkit'
import type { Action } from '@reduxjs/toolkit'
import { resetState } from './actions'

import authReducer from './auth/authSlice'
import uiReducer from './ui/uiSlice'
import workspaceReducer from './workspace/workspaceSlice'
import projectsReducer from './projects/projectsSlice'
import listsReducer from './lists/listsSlice'
import tasksReducer from './tasks/tasksSlice'
import commentsReducer from './comments/commentsSlice'
import notificationsReducer from './notifications/notificationsSlice'
import apiKeysReducer from './apiKeys/apiKeysSlice'
import activityReducer from './activity/activitySlice'
import agentStatusReducer from './agentStatus/agentStatusSlice'
import adminReducer from './admin/adminSlice'

export const appReducer = combineReducers({
    auth: authReducer,
    ui: uiReducer,
    workspace: workspaceReducer,
    projects: projectsReducer,
    lists: listsReducer,
    tasks: tasksReducer,
    comments: commentsReducer,
    notifications: notificationsReducer,
    apiKeys: apiKeysReducer,
    activity: activityReducer,
    agentStatus: agentStatusReducer,
    admin: adminReducer,
})

export type RootState = ReturnType<typeof appReducer>

// Single, reliable reset path (SCD-932). On `resetState` (dispatched on logout) we feed
// `undefined` to the combined reducer, so EVERY slice — current and any added later —
// reinitializes to its initialState in one place. Previously each slice had to opt in via
// `addCase(resetState, …)` and six of them never did (ui, notifications, comments, apiKeys,
// activity, agentStatus), so the previous user's state leaked into the next sign-in. A root
// reset can't be forgotten by a new slice, which is what makes logout match a fresh session.
export const rootReducer = (state: RootState | undefined, action: Action): RootState =>
    appReducer(action.type === resetState.type ? undefined : state, action)
